import axios from "axios";

import { AccountType } from "shared/types/accounts";

import { JsonResp, unwrapJsonResp } from "../JsonResp";

export interface GmbLocation {
  id: string;
  name: string;
  sub: string;
  locationName?: string;
  title?: string;
  account: {
    name: string;
  };
  address?: {
    administrativeArea?: string;
    locality?: string;
    addressLines?: string[];
    postalCode?: string;
  };
  metadata?: {
    mapsUri?: string;
    mapsUrl?: string;
  };
}

export async function getGmbRedirect(
  reconnect: boolean = false
): Promise<string> {
  let url = "/gmb/request_token";
  if (reconnect) {
    url = url + "?reconnect=true";
  }
  const response = await axios.request<string>({ method: "get", url });
  return response.data;
}

export async function getAvailableGmbLocations({
  throwOnEmpty,
}: {
  throwOnEmpty: boolean;
}): Promise<GmbLocation[]> {
  const url = new URL(window.location.href);
  const response = await axios.request<JsonResp<GmbLocation[]>>({
    method: "get",
    url: `/gmb/locations/${url.searchParams.get("sub")}`,
  });
  const locations = unwrapJsonResp(response.data);
  if (throwOnEmpty && locations.length === 0) {
    throw Error("[throwOnEmpty] no gmb locations were returned");
  } else {
    return locations;
  }
}

export async function addGmbLocation(
  location: GmbLocation
): Promise<AccountType> {
  const response = await axios.request<JsonResp<AccountType>>({
    method: "post",
    url: `/gmb/locations/${location.sub}/${location.id}`,
  });
  return unwrapJsonResp(response.data);
}
